import { tuning } from "../state/tuning.js";
import type { PlayerState } from "../state/types.js";

const COINCIDENT_EPSILON = 1e-6;

export function resolvePlayerVsPlayer(players: PlayerState[]): void {
  const threshold = 2 * tuning.player.radius;
  // Callers pass `state.players`, which is in canonical sorted order (see
  // createMatch). The pair iteration below visits each unordered pair once.
  for (let i = 0; i < players.length; i++) {
    const a = players[i];
    if (a === undefined) continue;
    if (a.benched) continue;
    for (let j = i + 1; j < players.length; j++) {
      const b = players[j];
      if (b === undefined) continue;
      if (b.benched) continue;
      const dx = a.pos.x - b.pos.x;
      const dy = a.pos.y - b.pos.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist >= threshold) continue;
      const overlap = threshold - dist;
      const half = overlap / 2;
      let pushX: number;
      let pushY: number;
      if (dist < COINCIDENT_EPSILON) {
        pushX = 1;
        pushY = 0;
      } else {
        pushX = dx / dist;
        pushY = dy / dist;
      }
      a.pos.x += pushX * half;
      a.pos.y += pushY * half;
      b.pos.x -= pushX * half;
      b.pos.y -= pushY * half;
    }
  }
}
